var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_234_700",
    style: {
      "maskType": "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 4,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 18H21.25C21.9404 18 22.5 18.4477 22.5 19C22.5 19.5523 21.9404 20 21.25 20H8.75C8.05964 20 7.5 19.5523 7.5 19C7.5 18.4477 8.05964 18 8.75 18ZM14.116 15.7071L10.5805 12.8787C10.0923 12.4882 10.0923 11.855 10.5805 11.4645C11.0686 11.0739 11.8601 11.0739 12.3482 11.4645L13.7499 12.5858V5C13.7499 4.44772 14.3095 4 14.9999 4C15.6902 4 16.2499 4.44772 16.2499 5V12.5858L17.6515 11.4645C18.1397 11.0739 18.9312 11.0739 19.4193 11.4645C19.9075 11.855 19.9075 12.4882 19.4193 12.8787L15.8838 15.7071C15.6576 15.8881 15.3451 16 14.9999 16C14.6547 16 14.3422 15.8881 14.116 15.7071Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_234_700)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 24,
    fill: "#232323"
  }))));
};

export default __webpack_public_path__ + "static/media/icon-catalog-download.8278a99a.svg";
export { SvgComponent as ReactComponent };